@if (dataLoaded) {
  <div class="h-100 w-100" [innerHtml]="media"></div>
} @else {
  <div class="pt-5 w-100 h-100">
    @if (!loadError) {
      <div class="search-skeleton mx-auto"></div>
    }
    @if (loadError) {
      <div class="card w-50 d-block mx-auto">
        <div class="card-body text-danger text-center py-4">
          {{'BO_DOCUMENT_LOAD_ERROR' | translate}}
        </div>
      </div>
    }
  </div>
}

